/**
 * Explicit service-worker registration (spec §6.3).
 *
 * Registers the Workbox-generated SW in production only. Disabled
 * during ``vite dev`` so HMR + the dev API proxy aren't interfered
 * with by stale caches.
 *
 * Updates are automatic (``registerType: "autoUpdate"`` in vite.config):
 * a newly deployed SW skips waiting and claims open pages, and the plugin
 * reloads this page once it takes control. Update checks run as the page
 * loads, so that reload lands before anyone has started typing. Pages still
 * running an older build pick the new one up on their next load; a stale
 * lazy chunk in between is caught by ``lazyWithReload``.
 */
import { registerSW } from "virtual:pwa-register";

export function registerServiceWorker(): void {
  if (typeof window === "undefined") return;
  if (!import.meta.env.PROD) return;
  registerSW({
    immediate: true,
    onOfflineReady: () => {
      console.info("[pwa] offline-ready");
    },
  });
}
